import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterDate_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template"
import {filterUser_template} from "./filterUser_template";
import {filterArticle_template} from "./filterArticle_template";
import {filterPreset_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterPreset_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";

declare var ko: any;

interface Option { id: number; name: string }
interface Currency { id: number; currency: string }
interface Brand extends Option {}
interface ItemType extends Option {}
interface ActionType extends Option {}
interface CreationType extends Option {}
interface Role extends Option {}
interface Type extends Option {}
interface Status extends Option {}
interface EntryType extends Option {}
interface TimePeriod { id: number, start: string, end: string}
interface Account extends Option{ description: string}
interface ArticleGroup {
    id: number,
    groupType: string,
    "dateStart": string,
    "dateEnd": string,
    "dateCreated": string,
    "dateUpdated": string
}

export class transactionsList_template extends vnTemplate {

    protected paymentStatusFilter: multipleSelector_template;
    protected paymentTypeFilter: multipleSelector_template;
    protected paymentCreationTypeFilter: multipleSelector_template;
    protected paymentCurrencyFilter: multipleSelector_template;
    protected paymentEntryTypeFilter: multipleSelector_template;
    protected paymentActionTypeFilter: multipleSelector_template;
    protected paymentRoleFilter: multipleSelector_template;
    protected brandFilter: multipleSelector_template;
    protected paymentItemTypeFilter: multipleSelector_template;
    protected paymentTimePeriodFilter: filterDropdown_template;
    protected filterUser: filterUser_template;
    protected filterArticle: filterArticle_template;
    protected dateFilter: filterDate_template;
    protected pagination: pagination_template;
    protected validationsList: validationsList_template;
    protected paymentAccountFilter: multipleSelector_template;
    protected paymentArticleGroupFilter: filterDropdown_template;
    protected filterPreset: filterPreset_template;

    protected resultInfos: resultsInfo_template;

    protected getTemplateHtml(): string {
        return `
            <div class="sub-header filter-preset w-justify ">

                    ` + this.filterPreset.getHtmlBuild() + `
            </div>
            <div class="sub-header">
            
                <div class="w-justify">
                    <div class="w-left">
                        <div> ${ this.paymentStatusFilter.getHtmlBuild() }</div>
                        <div> ${ this.paymentTypeFilter.getHtmlBuild() }</div>           
                        <div> ${ this.paymentCreationTypeFilter.getHtmlBuild() }</div>
                        <div> ${ this.paymentCurrencyFilter.getHtmlBuild() }</div>
                        <div> ${ this.paymentEntryTypeFilter.getHtmlBuild() }</div>
                        <div> ${ this.paymentActionTypeFilter.getHtmlBuild() }</div>
                        <div> ${ this.paymentRoleFilter.getHtmlBuild() }</div>
                        <div data-bind="visible: showBrandFilter"> ${ this.brandFilter.getHtmlBuild() }</div>
                        <div> ${ this.paymentItemTypeFilter.getHtmlBuild() }</div>
                        <div> ${ this.paymentAccountFilter.getHtmlBuild() }</div>
                        <div data-bind="css: {disabledDiv: !enableTimePeriodFilter()}">
                            <label class="form-label form-label-box">Time Period</label> ${ this.paymentTimePeriodFilter.getHtmlBuild() }
                        </div>
                        <div data-bind="css: {disabledDiv: !enableArticleGroupFilter()}">
                            <label class="form-label form-label-box">Article Groups</label> ${ this.paymentArticleGroupFilter.getHtmlBuild() }
                        </div>
                        ${ this.filterUser.getHtmlBuild() }
                        <!-- ko if: brand() != 'VN' -->
                            ${ this.filterArticle.getHtmlBuild() }
                        <!-- /ko -->
                        ${ this.dateFilter.getHtmlBuild() }
                    </div>
                </div>      
            </div>
            <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                    <div id="selected-status"></div>
                    <div id="selected-types"></div>
                    <div id="selected-item-types"></div>
                    <div id="selected-creations"></div>
                    <div id="selected-currencies"></div>
                    <div id="selected-entries"></div>
                    <div id="selected-actions"></div>
                    <div id="selected-roles"></div>
                    <div id="selected-brands"></div>
                    <div id="selected-accounts"></div>
                    <div id="selected-users"></div>
                </div>
            </div>
            
            ${ this.validationsList.getHtmlBuild() }
           
            <div class="list-header w-justify" >
                <div class="w-left" >
                    <button data-bind="click: onClickAdd, visible: canEditTransaction" class="btn secondary icon i-add" type="button">Add Transaction</button>
                </div>
                
                <div class="w-right">
                    <div id="pagination" class="w-pagination" data-bind="template: { name: 'pagination-template', data: pagination }">
                        <div class="pagination">
                            <input data-bind="value: pageNumber" type="hidden" value="1">
                            <span><a data-bind="event: { click: onClickPageFirst }" class="hidden prev">first</a></span>
                            <ul data-bind="foreach: pages">
                            <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page active">1</a></li>
                    
                            <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page">2</a></li>
                    
                            <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page">3</a></li>
                            </ul>
                            <span><a data-bind="event: { click: onClickPageLast }" class="hidden next">last</a></span>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="w-list-results" data-bind="css: { loading: isLoading }">
               
                <table class="list-results">
                ` + this.resultInfos.getHtmlBuild() +`
                    <thead>
                        <tr>
                            <th><span></span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'id') }, css: { 'list-sort-desc': orderByAndDirection()=='id_DESC', 'list-sort-asc': orderByAndDirection()=='id_ASC' }">ID</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'name') }, css: { 'list-sort-desc': orderByAndDirection()=='name_DESC', 'list-sort-asc': orderByAndDirection()=='name_ASC' }">Name</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'amount') }, css: { 'list-sort-desc': orderByAndDirection()=='amount_DESC', 'list-sort-asc': orderByAndDirection()=='amount_ASC' }">Amount</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'currency_name') }, css: { 'list-sort-desc': orderByAndDirection()=='currency_name_DESC', 'list-sort-asc': orderByAndDirection()=='currency_name_ASC' }">Currency</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'entryType_name') }, css: { 'list-sort-desc': orderByAndDirection()=='entryType_name_DESC', 'list-sort-asc': orderByAndDirection()=='entryType_name_ASC' }">Entry Type</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'user_fullName') }, css: { 'list-sort-desc': orderByAndDirection()=='user_fullName_DESC', 'list-sort-asc': orderByAndDirection()=='user_fullName_ASC' }">User</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'itemType_name') }, css: { 'list-sort-desc': orderByAndDirection()=='itemType_name_DESC', 'list-sort-asc': orderByAndDirection()=='iitemType_name_ASC' }">Item Type</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'status_name') }, css: { 'list-sort-desc': orderByAndDirection()=='status_name_DESC', 'list-sort-asc': orderByAndDirection()=='status_name_ASC' }">Status</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'type_name') }, css: { 'list-sort-desc': orderByAndDirection()=='type_name_DESC', 'list-sort-asc': orderByAndDirection()=='type_name_ASC' }">Type</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateCreation') }, css: { 'list-sort-desc': orderByAndDirection()=='dateCreation_DESC', 'list-sort-asc': orderByAndDirection()=='dateCreation_ASC' }">Created On</span>
                            </th>
                            <th><span class="icon icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateTransaction') }, css: { 'list-sort-desc': orderByAndDirection()=='dateTransaction_DESC', 'list-sort-asc': orderByAndDirection()=='dateTransaction_ASC' }">Transaction Date</span>
                                <div class="ww-tooltips">
                                    <button class="w-tooltips icon i-tooltips" type="button">
                                        <span class="tooltips no-wrap left">This field marks the source moment that generated the transaction</span>
                                    </button>
                                </div>
                            </th>
                            <th><span class="icon icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateScheduled') }, css: { 'list-sort-desc': orderByAndDirection()=='dateScheduled_DESC', 'list-sort-asc': orderByAndDirection()=='dateScheduled_ASC' }">Scheduled On</span>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'created_by') }, css: { 'list-sort-desc': orderByAndDirection()=='created_by_DESC', 'list-sort-asc': orderByAndDirection()=='created_by_ASC' }">Created By</span></th>
                            
                            <th></th>
                            <th></th>
    
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: payments">
                        <tr>
                            <td></td>
                            <td data-bind="event: { click: $parent.onClickEdit }"><a class="right-click" data-bind="attr: {href: emakiEdit}"><span data-bind="text: id"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickEdit }"><a class="right-click" data-bind="attr: {href: emakiEdit}"><span data-bind="text: name"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickEdit }"><a class="right-click" data-bind="attr: {href: emakiEdit}"><span data-bind="text: amount"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickEdit }"><a class="right-click" data-bind="attr: {href: emakiEdit}"><span data-bind="text: currency_name"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickEdit }"><a class="right-click" data-bind="attr: {href: emakiEdit}"><span data-bind="text: entryType_name"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickEdit }"><a class="right-click" data-bind="attr: {href: emakiEdit}"><span data-bind="text: user_fullName"></span></a></td>                        
                            <td data-bind="event: { click: $parent.onClickEdit }"><a class="right-click" data-bind="attr: {href: emakiEdit}"><span data-bind="text: itemType_name"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickEdit }"><a class="right-click" data-bind="attr: {href: emakiEdit}"><span data-bind="text: status_name"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickEdit }"><a class="right-click" data-bind="attr: {href: emakiEdit}"><span data-bind="text: type_name"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickEdit }"><a class="right-click" data-bind="attr: {href: emakiEdit}"><span data-bind="text: dateCreation"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickEdit }"><a class="right-click" data-bind="attr: {href: emakiEdit}"><span data-bind="text: dateTransaction"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickEdit }"><a class="right-click" data-bind="attr: {href: emakiEdit}"><span data-bind="text: dateScheduled"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickEdit }"><a class="right-click" data-bind="attr: {href: emakiEdit}"><span data-bind="text: created_by"></span></a></td>
                            <td class="no-wrap">
                                <button data-bind="event: { click: $parent.onClickDelete }, visible: $parent.canDeleteTransaction" class="btn only-icon border highlight icon i-delete" type="button"></button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            
            </div>
            
            `;
    }

    protected initPartial(): void {


        this.setBrand(this.caller.getTransactionSystem());

        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;

        this.paymentStatusFilter = new multipleSelector_template("paymentStatusFilter", this.getTemplateViewModel(), this.caller);
        this.paymentStatusFilter.setLabel("Status");
        this.paymentStatusFilter.setFilterContainerClass('margin-neg');
        this.paymentStatusFilter.setTagContainerId('selected-status');
        this.paymentStatusFilter.setTagContainerCaption('Selected status:');

        this.paymentActionTypeFilter = new multipleSelector_template("paymentActionTypeFilter", this.getTemplateViewModel(), this.caller);
        this.paymentActionTypeFilter.setLabel('Actions');
        this.paymentActionTypeFilter.setFilterContainerClass('margin-neg');
        this.paymentActionTypeFilter.setTagContainerId('selected-actions');
        this.paymentActionTypeFilter.setTagContainerCaption('Selected actions:');

        this.paymentCreationTypeFilter = new multipleSelector_template("paymentCreationTypeFilter", this.getTemplateViewModel(), this.caller);
        this.paymentCreationTypeFilter.setLabel("Creation Types");
        this.paymentCreationTypeFilter.setFilterContainerClass('margin-neg');
        this.paymentCreationTypeFilter.setTagContainerId('selected-creations');
        this.paymentCreationTypeFilter.setTagContainerCaption('Selected creations:');

        this.paymentItemTypeFilter = new multipleSelector_template("paymentItemTypeFilter", this.getTemplateViewModel(), this.caller);
        this.paymentItemTypeFilter.setLabel("Item Types");
        this.paymentItemTypeFilter.setFilterContainerClass('margin-neg');
        this.paymentItemTypeFilter.setTagContainerId('selected-item-types');
        this.paymentItemTypeFilter.setTagContainerCaption('Selected item types:');

        this.paymentTypeFilter = new multipleSelector_template("paymentTypeFilter", this.getTemplateViewModel(), this.caller);
        this.paymentTypeFilter.setLabel("Types");
        this.paymentTypeFilter.setFilterContainerClass('margin-neg');
        this.paymentTypeFilter.setTagContainerId('selected-types');
        this.paymentTypeFilter.setTagContainerCaption('Selected types:');

        this.paymentEntryTypeFilter = new multipleSelector_template("paymentEntryTypeFilter", this.getTemplateViewModel(), this.caller);
        this.paymentEntryTypeFilter.setLabel("Entries");
        this.paymentEntryTypeFilter.setFilterContainerClass('margin-neg');
        this.paymentEntryTypeFilter.setTagContainerId('selected-entries');
        this.paymentEntryTypeFilter.setTagContainerCaption('Selected entry types:');

        this.paymentCurrencyFilter = new multipleSelector_template("paymentCurrencyFilter", this.getTemplateViewModel(), this.caller);
        this.paymentCurrencyFilter.setLabel("Currencies");
        this.paymentCurrencyFilter.setFilterContainerClass('margin-neg');
        this.paymentCurrencyFilter.setTagContainerId('selected-currencies');
        this.paymentCurrencyFilter.setTagContainerCaption('Selected currencies:');

        this.brandFilter = new multipleSelector_template("brandFilter", this.getTemplateViewModel(), this.caller);
        this.brandFilter.setLabel("Brands");
        this.brandFilter.setFilterContainerClass('margin-neg');
        this.brandFilter.setTagContainerId('selected-brands');
        this.brandFilter.setTagContainerCaption('Selected brands:');


        this.paymentRoleFilter = new multipleSelector_template("paymentRoleFilterList", this.getTemplateViewModel(), this.caller);
        this.paymentRoleFilter.setLabel('Roles');
        this.paymentRoleFilter.setFilterContainerClass('margin-neg');
        this.paymentRoleFilter.setTagContainerId('selected-roles');
        this.paymentRoleFilter.setTagContainerCaption('Selected roles:');

        this.paymentTimePeriodFilter = new filterDropdown_template("paymentTimePeriodFilter", this.getTemplateViewModel(), this.caller);

        let currentDate = new Date();
        this.dateFilter = new filterDate_template("dateFilter", this.getTemplateViewModel(), this.caller);
        this.dateFilter.setDateRange(
            new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - 9, 0, 0, 0),
            new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 23, 59, 59),
        );
        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this.caller);

        this.filterUser = new filterUser_template("filterUser", this.getTemplateViewModel(), this.caller);
        this.filterUser.asMultipleSelectionMode();
        this.filterUser.setTagContainerId('selected-users');
        this.filterUser.setTagContainerCaption('Selected user:');
        this.filterUser.setPlaceholderText("User");

        this.filterArticle = new filterArticle_template("filterArticle", this.getTemplateViewModel(), this.caller);

        this.paymentAccountFilter  = new multipleSelector_template("paymentAccountFilter", this.getTemplateViewModel(), this.caller);
        this.paymentAccountFilter.setLabel('Accounts');
        this.paymentAccountFilter.setFilterContainerClass('margin-neg');
        this.paymentAccountFilter.setTagContainerId('selected-accounts');
        this.paymentAccountFilter.setTagContainerCaption('Selected Accounts:');


        this.paymentArticleGroupFilter = new filterDropdown_template("paymentArticleGroupFilter", this.getTemplateViewModel(), this.caller);

        this.filterPreset = new filterPreset_template("filterPreset", this.getTemplateViewModel(), this.caller);
        this.filterPreset.getTemplateViewModel().searchPresetType('brandTransactions');

        this.resultInfos = new resultsInfo_template('resultInfo', this.getTemplateViewModel(), this.caller);
    }

    protected getTemplateName(): string {

        return "transactionsList-template";
    }

    protected getMainElementType(): string {

        return "div";
    }

    protected buildViewModel(): any {

        let self = this;
        return {
            brand: ko.observable('VN'),
            orderBy: ko.observable("dateCreation"),
            orderByAndDirection: ko.observable("dateCreation_DESC"),
            orderByDirection: ko.observable("DESC"),
            payments: ko.observableArray([]),
            isLoading: ko.observable(0),
            canEditTransaction: ko.observable(false),
            canSearchUsers: ko.observable(false),
            canDeleteTransaction: ko.observable(false),
            transactionSystem: ko.observable(""),
            showBrandFilter: ko.observable(false),
            enableTimePeriodFilter: ko.observable(true),
            enableArticleGroupFilter: ko.observable(true),
            onClickReorder: function (value, data, event) {
                self.onClickReorder(value, data, event);
            },
            onClickAdd: function () {
                self.onClickAdd();
            },
            onClickEdit: function (value, data, event) {
                self.onClickEdit(value, data, event);
            },
            onClickDelete: function (value, data, event) {
                self.onClickDelete(value, data, event);
            }
        };
    }

    private setBrand(brand: string): void  {
        this.getTemplateViewModel().brand(brand);
    }

    public buildDatePickerCalendar(){

        this.dateFilter.buildCalendar();
    }

    public getViewModelForRequest() {

        return {
            orderBy: this.getTemplateViewModel().orderBy,
            orderByDirection: this.getTemplateViewModel().orderByDirection,
            pagination: this.getTemplateViewModel().pagination,
            searchPresetName: this.getTemplateViewModel().filterPreset.searchPresetName(),
            searchPresetType: (this.getTemplateViewModel().transactionSystem() == 'VN') ? 'networkTransactions' : 'brandTransactions',
            filters: {
                status: this.getTemplateViewModel().paymentStatusFilter.selectedItems,
                types: this.getTemplateViewModel().paymentTypeFilter.selectedItems,
                creationTypes: this.getTemplateViewModel().paymentCreationTypeFilter.selectedItems,
                currencies: this.getTemplateViewModel().paymentCurrencyFilter.selectedItems,
                entryTypes: this.getTemplateViewModel().paymentEntryTypeFilter.selectedItems,
                itemTypes: this.getTemplateViewModel().paymentItemTypeFilter.selectedItems,
                actionTypes: this.getTemplateViewModel().paymentActionTypeFilter.selectedItems,
                timePeriod: this.getTemplateViewModel().paymentTimePeriodFilter.selectedOption,
                brands: this.getTemplateViewModel().brandFilter.selectedItems,
                roles: this.getTemplateViewModel().paymentRoleFilterList.selectedItems,
                users: this.filterUser.getUsersForRequest(),
                idArticle: this.getTemplateViewModel().filterArticle.idArticle,
                articleTitle: this.getTemplateViewModel().filterArticle.article,
                dateFilterType: this.getTemplateViewModel().dateFilter.selectedFilter(),
                startDate: this.getTemplateViewModel().dateFilter.startDate(),
                endDate: this.getTemplateViewModel().dateFilter.endDate(),
                startDateRange: this.getTemplateViewModel().dateFilter.fromRange(),
                endDateRange: this.getTemplateViewModel().dateFilter.toRange(),
                dateCreated: this.getTemplateViewModel().dateCreatedFilter,
                accounts: this.getTemplateViewModel().paymentAccountFilter.selectedItems,
                articleGroup: this.getTemplateViewModel().paymentArticleGroupFilter.selectedOption
            }
        }
    }

    public activateLoading() {
        this.getTemplateViewModel().isLoading(1);
    }

    public deactivateLoading() {
        this.getTemplateViewModel().isLoading(0);
    }

    public setPayments(payments, brandId) {
        let pUrl = '/payment/transactions/edit/';
        if (brandId) {
            pUrl = '/brand/' + brandId + '/payment/transactions/edit/';
        }
        payments.forEach((p) => p['emakiEdit'] = pUrl + p.id);
        this.getTemplateViewModel().payments(payments);
    }

    public setUsers(users) {

        this.getTemplateViewModel().filterUser.users(users);
    }

    public setArticles(articles) {

        this.getTemplateViewModel().filterArticle.articles(articles);
    }

    public onClickAdd() {

        this.caller.addTransaction();
    }

    protected onBlurUser(data, event) {

        this.getTemplateViewModel().user(data.valnet_user.fullNameAndLogin)
        this.getTemplateViewModel().currency(data.valnet_paymentInfo.currency.currency);
        this.getTemplateViewModel().idCurrency(data.valnet_paymentInfo.currency.id);
        this.getTemplateViewModel().idUser(data.id);
        this.getTemplateViewModel().isShowUserSuggestions(false);
    }

    protected onBlurArticle(data, event) {

        this.getTemplateViewModel().article(data.title)
        this.getTemplateViewModel().idItem(data.id);
        this.getTemplateViewModel().isShowArticleSuggestions(false);
    }

    public onClickEdit(value, data, event) {

        this.caller.editTransaction(value.id);
    }

    public onClickDelete(value, data, event) {

        this.caller.deleteTransaction(value.id);
    }

    public onClickReorder(value, data, event) {

        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.transactionListReorder();
    }

    protected onUpdateError(requestStatus: any, responseParsed): void {

        let msg = "error: while obtaining the form data - (" + responseParsed.message + ")";
        this.validationsList.setSingleMessage({field: "error", "label": requestStatus, message: msg});
    }

    public setCanEditTransactions(canEditTransaction: boolean){

        this.getTemplateViewModel().canEditTransaction(canEditTransaction);
    }

    public setCanDeleteTransactions(canDeleteTransaction: boolean){

        this.getTemplateViewModel().canDeleteTransaction(canDeleteTransaction);
    }

    public setCanSearchUsers(canSearchUsers: boolean){

        this.filterUser.setIsVisible(canSearchUsers);
    }

    public setTransactionSystem(transactionSystem){
        if (transactionSystem == "VN"){
            this.getTemplateViewModel().showBrandFilter(true);
        }
        this.getTemplateViewModel().transactionSystem(transactionSystem);
    }

    public setPaymentItemTypeFilterOptions(itemTypes:  Array<ItemType>): void {

        let filteredItemTypesByLevel = this.filterItemTypesFilter(itemTypes);
        this.paymentItemTypeFilter.setItems(filteredItemTypesByLevel);
    }

    public setPaymentActionTypeFilterItems(actions: Array<ActionType>): void {

        this.paymentActionTypeFilter.setItems(actions);
    }

    public setPaymentCreationTypeFilterItems(creations: Array<CreationType>): void {

        this.paymentCreationTypeFilter.setItems(creations);
    }

    public setPaymentRoleFilterItems(roles: Array<Role>): void {

        this.paymentRoleFilter.setItems(roles);
    }

    public setPaymentTypeFilterItems(types: Array<Type>): void {

        this.paymentTypeFilter.setItems(types);
    }

    public setPaymentStatusFilterItems(status: Array<Status>): void {

        this.paymentStatusFilter.setItems(status);
    }

    public setPaymentEntryTypeFilterItems(entryTypes: Array<EntryType>): void {

        this.paymentEntryTypeFilter.setItems(entryTypes);
    }

    public setPaymentCurrencyFilterItems(currencies: Array<Currency>): void {

        let currencyItems = [];
        for (let item of currencies) {
            currencyItems.push({id: item.id, name: item.currency})
        }

        this.paymentCurrencyFilter.setItems(currencyItems);
    }

    public setPaymentTimePeriodFilterItems(timePeriods: Array<TimePeriod>): void {

        let periods = [];
        periods.push({id: 0, name: 'All'});
        for (let timePeriod of timePeriods) {
            periods.push({id: timePeriod.id, name: String(timePeriod.start).concat(' - ').concat(timePeriod.end)});
        }

        this.paymentTimePeriodFilter.setOptions(periods);
    }

    public setBrandFilterItems(brands: Array<Brand>): void {

        this.brandFilter.setItems(brands);
    }

    public showPeriodTimesFilter(): boolean {

        let itemTypesToShowPeriods = [6, 11];
        let selectedItemTypes = this.paymentItemTypeFilter.getSelectedItems();
        let filtered = selectedItemTypes.filter((it) => (itemTypesToShowPeriods.indexOf(it) !== -1));

        return (selectedItemTypes.length == 0 || filtered.length != 0) ;
    }

    public isPeriodTimesFilterVisible(): boolean {

        return this.getTemplateViewModel().enableTimePeriodFilter();
    }

    public setEnableTimePeriodFilter(showOrHide: boolean): void {

        if (!showOrHide) {

            this.paymentTimePeriodFilter.setSelectedOption(0);
        }
        this.getTemplateViewModel().enableTimePeriodFilter(showOrHide);
    }

    public showArticleGroupsFilter(): boolean {

        let itemTypesToShowPeriods = [12];
        let selectedItemTypes = this.paymentItemTypeFilter.getSelectedItems();
        let filtered = selectedItemTypes.filter((it) => (itemTypesToShowPeriods.indexOf(it) !== -1));

        return (selectedItemTypes.length == 0 || filtered.length != 0);
    }

    public setEnableArticleGroupFilter(showOrHide: boolean): void {

        if (!showOrHide) {

            this.paymentArticleGroupFilter.setSelectedOption(0);
        }
        this.getTemplateViewModel().enableArticleGroupFilter(showOrHide);
    }


    public setPaymentAccountsFilterItems(entryTypes: Array<Account>): void {

        this.paymentAccountFilter.setItems(entryTypes);
    }

    public setPaymentArticleGroupsFilterItems(articleGroups: Array<ArticleGroup>): void {

        let options = [];
        options.push({id: 0, name: 'All'});
        articleGroups.forEach((ar) => {
            options.push({id: ar.id, name: ar.dateStart + ' - ' + ar.dateEnd})
        });
        this.paymentArticleGroupFilter.setOptions(options);
    }

    public setViewModelFromRequest(urlParams){

        //check if URL has filters or user preferences
        if (urlParams != null){

            // date filters.
            if(urlParams.dateFilterType){
                this.dateFilter.getTemplateViewModel().selectedFilter(urlParams.dateFilterType)
            }
            if(urlParams.startDateRange || urlParams.endDateRange){

                this.dateFilter.setRange(urlParams.startDateRange, urlParams.endDateRange);
            }

            if(urlParams.startDate || urlParams.endDate) {
                this.setDateFilters(urlParams.startDate, urlParams.endDate);
            }

            this.setFilterSelectedItems(this.paymentStatusFilter, urlParams.status);
            this.setFilterSelectedItems(this.paymentTypeFilter, urlParams.types);
            this.setFilterSelectedItems(this.paymentCreationTypeFilter, urlParams.creationTypes);
            this.setFilterSelectedItems(this.paymentCurrencyFilter, urlParams.currencies);
            this.setFilterSelectedItems(this.paymentItemTypeFilter, urlParams.itemTypes);
            this.setFilterSelectedItems(this.paymentActionTypeFilter, urlParams.actionTypes);
            this.setFilterSelectedItems(this.paymentEntryTypeFilter, urlParams.entryTypes);
            this.setFilterSelectedItems(this.brandFilter, urlParams.brands);
            this.setFilterSelectedItems(this.paymentRoleFilter, urlParams.roles);
            this.setFilterSelectedItems(this.paymentAccountFilter, urlParams.accounts);

            this.getTemplateViewModel().paymentTimePeriodFilter.selectedOption(urlParams.timePeriod);
            this.getTemplateViewModel().paymentArticleGroupFilter.selectedOption(urlParams.articleGroup);

            let title = urlParams.articleTitle
            if(urlParams.idArticle && urlParams.articleTitle){

                title = urlParams.articleTitle.replaceAll("+", " ");
            }
            this.setArticlePresetFilter(this.filterArticle, urlParams.idArticle, title);

            if(urlParams.users) {
                this.filterUser.setSelectedUsersFromRequestParams(urlParams.users);
            } else {
                this.filterUser.resetTagContainer();
            }
        }
    }

    public setSearchPresets(presets){
        this.filterPreset.setSearchPresets(presets);
    }

    public addCreatedPresetToList(response){
        this.filterPreset.addCreatedPresetToList(response);
    }

    public setFilterSelectedItems(objFilter, urlParams){

        let splitString = [];

        // Multi select filters.
        if(urlParams){
            if(typeof urlParams == "string") {
                splitString = urlParams.split(",");
            } else if (typeof urlParams == "object") {
                splitString = urlParams;
            }else{
                splitString = [urlParams];
            }
            let arrayParam = [];
            let idTagArray = [];
            splitString.forEach((id) => {
                if(!isNaN(Number(id))){
                    id = Number(id);
                }else{
                    id = id.replaceAll("+", " ");
                }
                arrayParam.push({ id: id });
                idTagArray.push(id);
            });
            objFilter.setSelectedItems(arrayParam);
            objFilter.setTags(idTagArray, objFilter.getItems());
        }else{
            objFilter.setSelectedItems([]);
            objFilter.setTags([], objFilter.getItems());
        }
    }

    private setArticlePresetFilter(filterArticle: filterArticle_template, idArticle?: number, title?: string): void {

        filterArticle.getTemplateViewModel().idArticle(idArticle);
        filterArticle.getTemplateViewModel().article(title);
    }

    private setUserPresetFilter(userFilter: filterUser_template, idUser?: number, name?: string): void {

        userFilter.getTemplateViewModel().idUser(idUser);
        userFilter.getTemplateViewModel().user(name);
        userFilter.toggleCloseButton();
    }

    private setDateFilters(startDate, endDate) {
        if(startDate){
            startDate = new Date(startDate.replace(/-/g, '\/'));
        }
        if(endDate){
            endDate = new Date(endDate.replace(/-/g, '\/'));
        }

        this.dateFilter.setDateRange(startDate, endDate);
    }

    public setDefaults(){

        // date filters.
        this.dateFilter.getTemplateViewModel().selectedFilter("range");
        this.dateFilter.setRange("-15d", "15d");
    }

    public filterItemTypesFilter(itemTypes: Array<ItemType>):Array<ItemType> {

        let idBrand = this.caller.getTransactionSystem();

        let allowedItemTypes = [1, 3, 4, 5, 7, 8, 9, 10, 11, 12];
        if (idBrand == 'VN') {
            allowedItemTypes = [4, 5, 6, 7, 10, 11];
        }

        return itemTypes.filter(function (itemType) {
            return allowedItemTypes.indexOf(itemType.id) >= 0;
        });
    }
    public setResultInfo(nbResults, nbPages, execTime) {

        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/transactionsList_template.ts